import { WorkflowAttachmentPreviewController } from './workflow-attachment-preview.controller'

const component = {
  templateUrl: '/workflow/components/workflow-attachment-preview/workflow-attachment-preview.html?$$REVISION$$',
  bindings: {
    attachment: '<'
  },
  controllerAs: '$ctrl',
  controller: WorkflowAttachmentPreviewController
}

export const workflowAttachmentPreview = component
